<template>
    <div class="reo-nav nav-item">
        <a class="reo-nav-text">
            <span>{{ current }}</span>
            <span class="ui-icon icon-icon_down-2"></span>
        </a>
        <div class="nav-dropdown">
            <i class="border-gradient ui-gradient-blue"></i>
            <ul>
                <li v-for="(nav, index) in navList" :key="index"><router-link :to="{path: nav.path}">{{ nav.label }}</router-link></li>
            </ul>
        </div>
    </div>
</template>

<script>
import routerConfig from 'CONFIG/router';
export default {

    data () {

        let navList = routerConfig( this );
        return {

            navList

        };

    },
    computed: {

        current () {

            let path = this.$route.path;
            let navList = this.navList;
            for ( let nav in navList ) {

                if ( navList[ nav ].path === path ) {

                    return navList[ nav ].label;

                }

            }
            return this.$t( 'nav.cloud' );

        },

        currentLang () {

            return this.$store.state.lang.lang;

        }

    },

    watch: {

        currentLang () {

            this.navList = routerConfig( this );

        }

    }
    
};
</script>

<style scoped lang="less">
    .reo-nav{
        display: inline-block;
        line-height: 0.85rem;
        cursor: pointer;
    }
    .reo-nav:hover .nav-dropdown{
        display: block;
    }
    .reo-nav-text{
        font-weight: 500;
        font-size: 0.22rem;
    }
    .reo-nav .icon-icon_down-2{
        font-size: .12rem;
        margin-left: .15rem;
        position: relative;
        top: -.02rem;
    }
    .reo-nav .nav-dropdown{
        width: 2.3rem;
        display: none;
        background-color: #fff;
        margin: 0;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
    .reo-nav .nav-dropdown li{
        line-height: .6rem;
        position: relative;
    }
    .reo-nav .nav-dropdown li a{
        padding: 0 .25rem;
        color: #555;
        font-size: .16rem;
        font-weight: 500;
        text-decoration: none;
        display: block;
        text-align: center;
        line-height: .6rem;
        border-bottom: 0;
        margin: 0;
    }
    .reo-nav .nav-dropdown li a:hover{
        background-color: #f7f8f9;
        color: @theme;
    }

    .reo-nav .pc-body .nav-item:hover .nav-dropdown{
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/basic/Nav.vue